import { SWRConfig } from "swr";
import MembersList from "@/src/views/members/MembersList";
import promiseHash from "@/components/promiseHash";
import fetchAPI from "@/components/fetchAPI";

export async function getServerSideProps(context) {

  const search = new URLSearchParams(context.query);
  search.set('is_organization_user', 'false');

  const queryKey = '/api/users/?' + search.toString();

  const data = await promiseHash({
    members: fetchAPI(queryKey, {}, context),
    user: fetchAPI('/api/users/me/', {}, context),
  });

  const { members, user } = data;

  if (!user?.id) {
    return {
      redirect: {
        destination: '/login/?next=' + encodeURIComponent(context.resolvedUrl),
        permanent: false,
      }
    }
  }

  return {
    props: {
      fallback: {
        [queryKey]: members,
        '/api/users/me/': user
      }
    }
  }
}

export default function Index({ fallback }) {
  return (
    <SWRConfig value={{ fallback }}>
      <MembersList />
    </SWRConfig>
  )
}